<template>
    <v-card
        class="pb-2 pt-1 px-2"
        style="background-color:#f1ffdc; height: 550px; overflow-y: auto;"
    >
        <v-layout
            v-if="!feedbackList.length"
            justify-center
            align-center
            class="my-3 headline"
        >
            No Feedback
        </v-layout>
        <div v-if="feedbackList.length">
            <v-card
                class="pt-4 pb-2 px-3 my-3"
                v-for="(feedback, index) in feedbackList"
            >
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Date
                    </div>
                    <div>{{ feedback.date | time }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Caller ID
                    </div>
                    <div>{{ formatPhoneNumber(feedback.from) }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Category
                    </div>
                    <div>{{ feedback.category }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Status
                    </div>
                    <div>{{ feedback.status }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Note
                    </div>
                    <div>{{ feedback.note }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2" v-if="feedback.updatedBy">
                    <div class="font-weight-medium mr-1 width-200">
                        Updated By
                    </div>
                    <div>{{ feedback.updatedBy }}</div>
                </v-layout>
                <v-layout row class="ml-3 mb-2" v-if="feedback.updatedAt">
                    <div class="font-weight-medium mr-1 width-200">
                        Updated At
                    </div>
                    <div>{{ feedback.updatedAt | time }}</div>
                </v-layout>

                <audio
                    v-if="feedback.recording"
                    style="height: 25px; width: 300px;"
                    controls
                    class="ml-3"
                    :src="feedback.recording"
                ></audio>
            </v-card>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../../utils/helpers.js";

export default {
    props: {
        account: Object,
        feedbackList: Array,
    },
    data() {
        return {};
    },
    async created() {},
    computed: {},
    methods: {
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
    },
};
</script>
<style>
.multiple-feedback {
    overflow-y: auto;
    height: 500px !important;
}
</style>
